import styled, { RuleSet, css } from 'styled-components'
import { fluidSize, pxToRem } from '../../utils/style'

export const MODAL_FADE_EFFECT_DURATION = 200

export const Backdrop = styled.div.withConfig({
	shouldForwardProp: prop => prop !== 'visible' && prop !== 'customStyle',
})<{
	visible: boolean
	customStyle?: RuleSet<object>
}>`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: black;
	z-index: ${Number.MAX_SAFE_INTEGER - 1};
	opacity: 0;
	transition: opacity ${MODAL_FADE_EFFECT_DURATION}ms ease-in-out;

	${({ visible }) =>
		visible &&
		css`
			opacity: 1;
		`}

	${({ customStyle }) => customStyle}
`

export const Wrapper = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: ${Number.MAX_SAFE_INTEGER};
	transform: translate(-50%, -50%);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	padding-bottom: ${pxToRem(34)};
`

export const PositionWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`

export const CloseIconWrapper = styled.div`
	margin-left: auto;
	background-color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${fluidSize(28)};
	height: ${fluidSize(28)};
	border-radius: 50%;
	padding: ${fluidSize(10)};
	cursor: pointer;

	&:hover {
		background-color: #f1f1f1;
	}

	svg {
		height: 50%;
		width: 50%;
		fill: black;
	}
`
